import PropTypes from 'prop-types';
import Button from 'components/UI/Button';

const InsufficientValueScreen = ({
  literals,
  onContinueWithLowerAmount,
  onSelectOtherPledge,
  onBack,
}) => (
  <div className='full-screen-container digital-loan-result-screen'>
    <div className='screen-content'>
      <h1 className='digital-loan-phase2__title'>{literals.pageTitle}</h1>
      <p className='digital-loan-phase2__subtitle'>{literals.pageSubtitle}</p>
      <p className='digital-loan-phase2__body'>{literals.pageBody}</p>
      <p className='digital-loan-phase2__body'>{literals.optionsTitle}</p>
      <ul className='digital-loan-phase2__list'>
        {(literals.options || []).map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </div>
    <div className='screen-actions'>
      <Button
        text={literals.continueWithLowerAmount}
        onClick={onContinueWithLowerAmount}
      />
      <Button text={literals.selectOtherPledge} onClick={onSelectOtherPledge} />
      <Button text={literals.back} type='secondary' onClick={onBack} />
    </div>
  </div>
);

InsufficientValueScreen.propTypes = {
  literals: PropTypes.object.isRequired,
  onContinueWithLowerAmount: PropTypes.func.isRequired,
  onSelectOtherPledge: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default InsufficientValueScreen;
